import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IPagination {
  pageNumber: number;
  totalPages: number;
  onPageChange: (newPage: number) => void;
  leftButtonWrapper?: JSX.Element[];
  rightButtonWrapper?: JSX.Element[];
}

/**
 * @author taulmax
 * @date 2024.10.28
 * @description 페이지 컴포넌트
 */
const Pagination = ({
  pageNumber,
  totalPages,
  onPageChange,
  leftButtonWrapper,
  rightButtonWrapper,
}: IPagination) => {
  const pagesPerGroup = 10;
  const currentGroup = Math.floor(pageNumber / pagesPerGroup);
  const startPage = currentGroup * pagesPerGroup;
  const endPage = Math.min(startPage + pagesPerGroup, totalPages);

  const isFirstPage = pageNumber === 0;
  const isLastPage = pageNumber === totalPages - 1;
  const isFirstGroup = currentGroup === 0;
  const isLastGroup = endPage === totalPages;

  const handleFirstPage = () => {
    onPageChange(0); // 첫 번째 페이지로 이동
  };

  const handleLastPage = () => {
    onPageChange(totalPages - 1); // 마지막 페이지로 이동
  };

  const handlePreviousGroup = () => {
    if (!isFirstGroup) {
      onPageChange(startPage - 1);
    }
  };

  const handleNextGroup = () => {
    if (!isLastGroup) {
      onPageChange(endPage);
    }
  };

  const handlePageClick = (page: number) => {
    onPageChange(page);
  };

  return (
    <div className="pagination">
      <div className="pagination_left_button_wrapper">
        {leftButtonWrapper?.map(button => button)}
      </div>
      <div className="pagination_wrapper">
        <button
          className="page_button"
          onClick={handleFirstPage}
          disabled={isFirstPage}
          style={{ position: 'relative' }}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{ position: 'absolute', left: '11px' }}
          />
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{ position: 'absolute', left: '19px' }}
          />
        </button>
        <button
          className="page_button"
          onClick={handlePreviousGroup}
          disabled={isFirstGroup}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        {Array.from(
          { length: endPage - startPage },
          (_, i) => startPage + i
        ).map(page => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            disabled={page === pageNumber}
            className={`${
              page === pageNumber ? 'current_page' : ''
            } page_button`}
          >
            {page + 1}
          </button>
        ))}

        <button
          className="page_button"
          onClick={handleNextGroup}
          disabled={isLastGroup}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
        <button
          className="page_button"
          onClick={handleLastPage}
          disabled={isLastPage}
          style={{ position: 'relative' }}
        >
          <FontAwesomeIcon
            icon={faChevronRight}
            style={{ position: 'absolute', left: '11px' }}
          />
          <FontAwesomeIcon
            icon={faChevronRight}
            style={{ position: 'absolute', left: '19px' }}
          />
        </button>
      </div>
      <div className="pagination_right_button_wrapper">
        {rightButtonWrapper?.map(button => button)}
      </div>
    </div>
  );
};

export default Pagination;
